import { Injectable } from '@angular/core';
import { PreferencesService, PotentialJobsService, JobsService, WorkPreferences } from '@bluecrew/crew-member-backend-angular-client';

/**
 * Maintains the business logic for updating job preferences and getting the list of
 * jobs to display. May also provide job recommendations in the future, etc.
 */
@Injectable({
  providedIn: 'root'
})
export class JobService {
  constructor(private preferencesService: PreferencesService,
              private jobsService: JobsService,
              private potentialJobsService: PotentialJobsService) {
  }

  updateWorkPreferences(prefs: WorkPreferences /*, localPrefs: unknown */) {
    return this.preferencesService.updateWorkPreferences(prefs);
  }

  getWorkPreferences() {
    return this.preferencesService.getWorkPreferences();
  }

  getPotentialJobs() {
    // TODO optionally sort locally
    // Todo sort by this.prefs
    return this.potentialJobsService.getPotentialJobs();
  }

  getJobDetail(jobId) {
    return this.jobsService.getJobDetail(jobId);
  }

  getJobDetailAnonymous(jobId) {
    return this.jobsService.getJobDetailAnonymous(jobId);
  }
}
